<script>
import { formatNumber } from "../../helpers/formatting";

export default {
  props: {
    titulo: String,
    cantidad: Number,
    color: String,
  },
  methods: {
    formatNumber,
  },
};
</script>

<template>
  <div
    class="flex flex-col justify-between h-64 gap-2 rounded-xl bg-white p-4 text-[#043161] shadow-md"
  >
    <div>
      <slot name="ver"></slot>
    </div>
    <p class="text-lg sm:text-xl font-semibold">{{ titulo }}</p>
    <p class="text-lg sm:text-xl font-bold" v-bind:style="{ color: color }">
      {{ formatNumber(cantidad) }}
    </p>
  </div>
</template>
